import React from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import PropTypes from "prop-types";
import ReactCountryFlag from "react-country-flag";
import CustomCheckBox from "../../../components/CheckBox/index";

const ServiceAccessTable = ({
  entityaccess,
  paginationOnchange,
  paginationFirst,
  paginationRows,
}) => {
  const convertToTreeNodes = (data) => {
    return data.map((entity) => ({
      key: `entity-${entity.id}`,
      data: {
        name: (
          <span>
            <ReactCountryFlag
              countryCode={entity.country}
              svg
              className="mr-2"
            />
            {`${entity.name} (${entity.country})`}
          </span>
        ),
        status: null,
      },
      children: entity.services?.map((service) => {
        if (service?.name === "Payroll +") {
          const payrollPlusChild = {
            key: `process-payrollplus-${service.id}`,
            data: {
              name: "Payroll + (Payslip Integration)",
              status: (
                <div className="flex  text-center checkbox-margin">
                  <CustomCheckBox
                    inputId={`checkbox-payrollplus-${entity.id}-${service.id}`}
                    checked
                  />
                </div>
              ),
            },
          };

          return {
            key: `service-${service.id}`,
            data: {
              name: "Payroll +",
              status: null,
            },
            children: [payrollPlusChild],
          };
        }
        const children = service.process_templates?.map((process) => ({
          key: `process-${process.id}`,
          data: {
            name: process.name,
            status: (
              <div className="flex text-center checkbox-margin">
                <CustomCheckBox inputId={`checkbox-${process.id}`} checked />
              </div>
            ),
          },
        }));

        return {
          key: `service-${service.id}`,
          data: {
            name: service.name,
            status: null,
          },
          children,
        };
      }),
    }));
  };

  const treeNodes = convertToTreeNodes(entityaccess || []);

  return (
    <div className="user-access-table">
      <TreeTable
        value={treeNodes}
        emptyMessage="No results were found"
        responsiveLayout="scroll"
        paginator={entityaccess?.length > 10}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        rowsPerPageOptions={[10, 20, 30]}
        first={paginationFirst}
        rows={paginationRows}
        onPage={paginationOnchange}
      >
        <Column
          field="name"
          header="Entity"
          expander
          className="table-entity-column"
        />
        <Column
          field="status"
          header="Status"
          headerClassName="table-status-header"
        />
      </TreeTable>
    </div>
  );
};

ServiceAccessTable.propTypes = {
  entityaccess: PropTypes.array,
  paginationFirst: PropTypes.number,
  paginationRows: PropTypes.number,
  paginationOnchange: PropTypes.func,
};
export default ServiceAccessTable;
